<header id="headadmin">
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>
  <div class="card" id="cardprinc">
    <div class="card" id="cardsec">
      <div class="card-header" style="background-color: #be0c4d;">
        <h5 style="color: white;">Cargue Masivo</h5>
      </div>
      <div class="card-body">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-1">
              <a id="botonpdf" class="btn btn-light" data-bs-toggle="tooltip" title="Instructivo" [href]="pdfUrl" download></a>
            </div>
            <div class="col-11">
              <h4 style="text-align: center; color: gray;">Período Activo : {{PeriodoActivo.descripcionPeriodo}} de {{PeriodoActivo.anio}}</h4>
            </div>
          </div>
          <div class="row align-items-center" style="border: dashed; border-color: grey;">
            <div class="col-10">
              <div class="custom-file">
                <form enctype="multipart/form-data">
                  <input type="file" class="form-control" placeholder="Archivo" accept=".xlsx, .xls"
                   (change)="uploadFile($event)">
                </form>
              </div>
            </div>
            <div class="col-1">
              <a id="boton" class="btn btn-light" data-bs-toggle="tooltip" title="Plantilla" [href]="xlsxUrl" download></a>
            </div>
            <br>
            <div class="row" style="text-align: center;" *ngIf="continuar">
              <h5 style="color: darkblue;">Cargue exitoso!</h5>
            </div>
            <br>
          </div>
        </div>
      </div>
      <div class="card-footer justify-content-md">
        <div class="row">
          <div class="col-10" style="text-align: center;">
            <p *ngIf="errorcargue" style="color: #be0c4d;">Error en el cargue, por favor verifique en el siguiente link:</p>
            <a *ngIf="errorcargue" type="button" class="btn btn-link" id="exportar" (click)="download()" style="color: lightseagreen;">Verificar Cargue</a>
          </div>
          <div class="col-1 align-self-center">
            <button *ngIf="cargar" class="btn btn-secondary me-md-2" (click)="guardarDocumentoSuper()" [disabled]="btnCargar">Cargar</button>
            <button *ngIf="continuar" class="btn btn-secondary me-md-2" style="margin: 1px;" [disabled]="btnContinuar" (click)="siguienteModulo()">Continuar</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div style="display: none;">
    <table class="table table-responsive" id="PlantillaFuente">
      <thead>
        <tr>
          <td>CONSECUTIVO</td>
          <td>ANIO</td>
          <td>TRIMESTRE</td>
          <td>CODIGO TIPO ENTIDAD</td>
          <td>CODIGO ENTIDAD</td>
          <td>TIPO DE CREDITO</td>
          <td>DEPARTAMENTO</td>
          <td>MUNICIPIO</td>
          <td>SOLUCION VIVIENDA</td>
          <td>TENEDOR</td>
          <td>MONEDA</td>
          <td>RANGO VIVIENDA</td>
          <td>MORA</td>
          <td>NUMERO DE CREDITOS</td>
          <td>SALDO CAPITAL TOTAL</td>
          <td>CAPITAL DE 1 O MAS CUOTAS VENCIDAS</td>
          <td>TASA</td>
        </tr>
      </thead>
      <tbody>
      </tbody>
    </table>
  </div>

  <div style="display: none;">
    <table class="table table-responsive" id="ErroresCargue">
      <thead>
        <tr>
          <td>CONSECUTIVO</td>
          <td>ANIO</td>
          <td>TRIMESTRE</td>
          <td>CODIGO TIPO ENTIDAD</td>
          <td>CODIGO ENTIDAD</td>
          <td>TIPO DE CREDITO</td>
          <td>DEPARTAMENTO</td>
          <td>MUNICIPIO</td>
          <td>SOLUCION VIVIENDA</td>
          <td>TENEDOR</td>
          <td>MONEDA</td>
          <td>RANGO VIVIENDA</td>
          <td>MORA</td>
          <td>NUMERO DE CREDITOS</td>
          <td>SALDO CAPITAL TOTAL</td>
          <td>CAPITAL DE 1 O MAS CUOTAS VENCIDAS</td>
          <td>TASA</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let error of RespuestaCargueMasivo.contenido">
          <td>{{error.consecutivo}}</td>
          <td>{{error.anio}}</td>
          <td>{{error.trimestre}}</td>
          <td>{{error.cod_tipo_entidad}}</td>
          <td>{{error.codigo_entidad}}</td>
          <td>{{error.tipo_de_credito}}</td>
          <td>{{error.departamento}}</td>
          <td>{{error.municipio}}</td>
          <td>{{error.solucion_vivienda}}</td>
          <td>{{error.tenedor}}</td>
          <td>{{error.moneda}}</td>
          <td>{{error.rango_vivienda}}</td>
          <td>{{error.mora}}</td>
          <td>{{error.numero_creditos}}</td>
          <td>{{error.saldo_capital_total}}</td>
          <td>{{error.capital_una_mas_cuotas_vencidad}}</td>
          <td>{{error.tasa}}</td>
        </tr>
      </tbody>
    </table>
  </div>

</body>

<!--confirmar reporta periodo activo-->
<button class="btn btn-primary btn-sm" #openmodalperidoact data-toggle="modal"  data-target="#modal-confirma" style="visibility: hidden;" data-backdrop="static">ModPar</button>
<div class="modal fade bd-example-modal-lg" id="modal-confirma" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false" >
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h5 class="modal-title" id="modal" style="color: white;">Cargue Masivo CHV</h5>
        <!--button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
        </button-->
      </div>
      <div class="modal-body">
        <div class="card-body container-fluid">
          <div class="row">
            <div class="col-auto" style="margin: auto; color: #be0c4d;">
              <h5>Período Activo : {{PeriodoActivo.descripcionPeriodo}} de {{PeriodoActivo.anio}}</h5>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col-8">
              <p>¿La entidad va reportar información en el periodo de referencia?</p>
            </div>
            <div class="col">
              <div class="row">
                <div class="col-auto"><b>Si</b></div>
                <div class="col-auto"><input class="form-check-input" type="checkbox" value="true" id="si" [(ngModel)]="ReporPedRefSi"></div>
              </div>
            </div>
            <div class="col">
              <div class="row">
                <div class="col-auto"><b>No</b></div>
                <div class="col-auto"><input class="form-check-input" type="checkbox" value="false" id="no" [(ngModel)]="ReporPedRefNo"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-md-center">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" #closemodalperidoact style="visibility: hidden;">Close</button>
        <button type="button" class="btn btn-secondary" (click)="IrNovedades()">Siguiente</button>
      </div>
    </div>
  </div>
</div>
